import { useState } from "react";
import React from "react";
import styles from "../../language.module.scss";
import { addLangProps } from "../../types";
import Button from "../../../../components/Button";
import { ClipLoader } from "react-spinners";

const AddSpoken: React.FC<addLangProps> = ({
  value,
  setValue,
  handleSubmit,
  setStep,
  // languageList,
  isLoading,
}) => {
  const Langauges = ["Swahili", "Yoruba", "igbo", "Hausa", "English"];

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    setValue((prev) => ({
      ...prev,
      languages: [{ ...prev.languages[0], [e.target.name]: e.target.value }],
    }));
  };
  return (
    <form
      className={styles.selection}
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
        handleSubmit(e, "spoken");
        // setStep("list");
      }}
    >
      <div className={styles.selectBox}>
        <label htmlFor="langs">Language</label>
        {/* <select
          value={value.languages[0]?.language}
          onChange={handleSelect}
          id="langs"
          name="language"
        >
          <option>Select Language</option>
          {languageList?.map((language) => {
            return <option key={language?.id}>{language.name}</option>;
          })}
        </select> */}

        <input
          type="text"
          value={value.languages[0]?.language}
          id="langs"
          name="language"
          onChange={(e) => handleSelect(e)}
          className={styles.lngPut}
          placeholder="Language"
        />
      </div>
      <div className={styles.selectBox}>
        <label htmlFor="profs">Proficiency</label>
        <select
          value={value.languages[0]?.proficiency}
          onChange={handleSelect}
          id="profs"
          name="proficiency"
        >
          <option>Select Proficiency</option>
          <option value="native ">Native Speaker</option>
          <option value="intermediate">Intermediate</option>
          <option value="Expert"> Expert</option>
        </select>
      </div>

      <div className={styles.btnCont}>
        <Button variant="secondary" className={styles.btns}>
          {isLoading && <ClipLoader color="white" size={15} />}
          Save
        </Button>
        <Button variant="neutral" className={styles.btns} onClick={() => setStep("list")}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default AddSpoken;
